import { Pipe, PipeTransform } from '@angular/core';
import { UserService,  User } from '../shared';

@Pipe({
  name: 'dischargetypecountry'
})
export class DischargetypePipe implements PipeTransform {
  currentUser: User;
  dischargeMapData:any;
  private userService: UserService
  constructor()
  {}
  transform(value: any, args?: any): any {
    if(value)
   { 
    var changedFormat
    try{
      this.userService.currentUser.subscribe(
        (userData) => {
          this.currentUser = userData;
          if(this.currentUser.item && value){
            this.userService.getDischargeMapByPractice(this.currentUser.item.userAccountKey)
            .subscribe(data =>{
              this.dischargeMapData = data
              ////console.log("dischargeMapData", data);

              // if(args){
              //   // var filterlist = value.filter(item => item.dischargeTypeId == args)
              //   // if(filterlist.length>0)
              //   //    value = filterlist[0].dischargeTypeName;
                
              //     // if(this.dischargeMapData[args])
              //     //   value = this.dischargeMapData[args]
              //  }            
              // else{
                  value.forEach(element => {
                    if(this.dischargeMapData[element.dischargeTypeName]){
                      element.dischargeTypeName = this.dischargeMapData[element.dischargeTypeName]
                    }
                  });
              // }
              return value;
              // if(this.dischargeMapData[value]){
              //    value = this.dischargeMapData[value]
              // }           
            }       
          )
            //return value;
          // if(this.currentUser.item.language == 'en_uk'){
              

              
              ////console.log(JSON.stringify(value))
            // return value;
            //}
          //   else{
          //     value.forEach(element => {
          //       if(element.dischargeTypeId==1){
          //         element.dischargeTypeName = "Home w/Outpt"
          //       }
          //       if(element.dischargeTypeId==2){
          //         element.dischargeTypeName = "Home Health"
          //       }
          //       if(element.dischargeTypeId==3){
          //         element.dischargeTypeName = "SNF"
          //       }
          //       if(element.dischargeTypeId==4){
          //         element.dischargeTypeName = "Acute Rehab"
          //       }
          //       if(element.dischargeTypeId==5){
          //         element.dischargeTypeName = "Other"
          //       }
          //       if(element.dischargeTypeId==6){
          //         element.dischargeTypeName = "Hospital Readmission"
          //       }
          //       if(element.dischargeTypeId=='7'){
          //         element.dischargeTypeName = "Home w/out Services"
          //       }

          //     });
          //     ////console.log(JSON.stringify(value))
          //    // return value;
          //   }
            
          }
        }
        );     
        
      return value;
      }
      catch (Exception){
        return value;
      }  
  }
}

}
